import React from "react";
import { useSelector } from "react-redux";
import { inspectionSelector } from "../../redux/inspectionSlice";
import { surveySelector } from "../../redux/surveySlice";
import InspectionCard from "../home/InspectionCard";
import { Picutres } from "./Picutres";
import PreviewDetail from "./PreviewDetail";
const Preview = () => {
  const survey = useSelector(surveySelector);
  const inspection = useSelector(inspectionSelector);

  const keys = Object.keys(inspection);

  return (
    <>
      <InspectionCard survey={survey} />

      {keys.map(
        (objKey, index) =>
          objKey !== "code" &&
          objKey !== "ageOfBuild" &&
          objKey !== "sketch" &&
          objKey !== "id" &&
          objKey !== "photos" && <PreviewDetail key={index} title={objKey} />
      )}

      <Picutres />
    </>
  );
};

export default Preview;
